import classNames from "classnames";
import React, { ReactNode } from "react";
import Ellipse1 from "./Ellipse1.svg";
import Ellipse2 from "./Ellipse2.svg";
import DotPattern1 from "./dotPattern1.svg";
import DotPattern2 from "./dotPattern2.svg";
import styles from "./Background.module.scss";

type Props = {
  className?: string;
  childrenContainerClassName?: string;
  children?: ReactNode;
  childContainerComponent?: React.FC;
};

const BackgroundContainer: React.FC<Props> = ({
  className,
  children,
  childrenContainerClassName,
}) => {
  return (
    <main className={classNames(styles.wrapper, className)}>
      <div
        className={classNames(styles.otherChildren, childrenContainerClassName)}
      >
        {children}
      </div>
      <img
        src={Ellipse1}
        alt="Ellipse1"
        className={classNames(styles.child1)}
      />
      <img
        src={Ellipse2}
        alt="Ellipse2"
        className={classNames(styles.child2)}
      />
      <img
        src={DotPattern1}
        alt="dotpattern1"
        className={classNames(styles.child3)}
      />
      <img
        src={DotPattern2}
        alt="dotpattern2"
        className={classNames(styles.child4)}
      />
    </main>
  );
};

export default BackgroundContainer;
